
import React, { useEffect, useState } from "react";
import { getTaskTypes } from "../../../services/Lookups/TaskLookupService";
import TaskSubType from "../../../interfaces/task/TaskSubType";
import { useAuth } from "../../../firebase/AuthProvider";

interface AnalyticsFiltersProps {
  filters: any;
  onFiltersChange: (filters: any) => void;
}

const AnalyticsFilters: React.FC<AnalyticsFiltersProps> = ({
  filters,
  onFiltersChange,
}) => {
  const { currentUser } = useAuth();
  const [taskSubTypes, setTaskSubTypes] = useState<TaskSubType[]>([]);

  // TODO: Fetch real data for these dropdowns
  const teams = [
    { value: "team1", label: "Team 1" },
    { value: "team2", label: "Team 2" },
  ];

  useEffect(() => {
    const fetchTaskSubTypes = async () => {
      if (currentUser) {
        const token = await currentUser.getIdToken();
        const subtypes = await getTaskTypes(token);
        if (subtypes) {
          setTaskSubTypes(subtypes);
        }
      }
    };
    fetchTaskSubTypes();
  }, [currentUser]);

  const handleFilterChange = (filterName: string, value: any) => {
    const newFilters = { ...filters, [filterName]: value };
    onFiltersChange(newFilters);
  };

  return (
    <div className="flex gap-4 p-4 bg-gray-100 rounded-lg mb-4">
      <div>
        <label htmlFor="startDate" className="block text-sm font-medium text-gray-700">
          Start Date
        </label>
        <input
          type="date"
          id="startDate"
          value={filters.startDate || ""}
          onChange={(e) => handleFilterChange("startDate", e.target.value)}
          className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
        />
      </div>
      <div>
        <label htmlFor="endDate" className="block text-sm font-medium text-gray-700">
          End Date
        </label>
        <input
          type="date"
          id="endDate"
          value={filters.endDate || ""}
          onChange={(e) => handleFilterChange("endDate", e.target.value)}
          className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
        />
      </div>
      <div>
        <label htmlFor="team" className="block text-sm font-medium text-gray-700">
          Team
        </label>
        <select
          id="team"
          value={filters.teamId || ""}
          onChange={(e) => handleFilterChange("teamId", e.target.value)}
          className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
        >
          <option value="">All Teams</option>
          {teams.map((team) => (
            <option key={team.value} value={team.value}>
              {team.label}
            </option>
          ))}
        </select>
      </div>
      <div>
        <label htmlFor="taskSubType" className="block text-sm font-medium text-gray-700">
          Task Subtype
        </label>
        <select
          id="taskSubType"
          value={filters.taskSubTypeId || ""}
          onChange={(e) => handleFilterChange("taskSubTypeId", e.target.value)}
          className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
        >
          <option value="">All Subtypes</option>
          {taskSubTypes.map((subType) => (
            <option key={subType.id} value={subType.id}>
              {subType.type}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default AnalyticsFilters;
